import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import {
  validationSchema1,
  validationSchema2,
  validationSchema3,
  validationSchema4,
} from "../components/academics/create/add_std/utls/StudentValidate";
import { BSToADConvert, NepNowDateFormat } from "../widgets/DateFormat";
import { postDataToTheServer, putDataToTheServer } from "../widgets/api";
import AppURL from "../widgets/AppURL";
import { ToastSuccess, ToastWarning } from "../widgets/ToastMessage";
export const StudentEditFormData = React.createContext();

const StudentEditFormProvider = ({ children, studentData }) => {
  const [currentStep, setStep] = useState(1);
  const [studentDetails, setStudentDetails] = useState(studentData || []);

  const initialValues = {
    program: studentData?.program || "",
    acdmc_year: studentData?.acdmc_year || "",
    year_semester: studentData?.year_semester || "",
    medium: studentData?.medium || "",
    sec: studentData?.sec || "",
    team: studentData?.team || "",
    shift: studentData?.shift || "",
    maj_subj: studentData?.maj_subj || "",
    member_sn: studentData?.member_sn || "",
    first_name: studentData?.first_name || "",
    middle_name: studentData?.middle_name || "",
    last_name: studentData?.last_name || "",
    name_nep: studentData?.name_nep || "",
    per_add: studentData?.per_add || "",
    province: studentData?.province || "",
    district: studentData?.district || "",
    municipality: studentData?.municipality || "",
    wardno: studentData?.wardno || "",
    add_nep: studentData?.add_nep || "",
    tempadd: studentData?.tempadd || "",
    father_name: studentData?.father_name || "",
    mother_name: studentData?.mother_name || "",
    marital_status: studentData?.marital_status || "2",
    gender: studentData?.gender || "",
    dobe: studentData?.dobe || "",
    dobn: studentData?.dobn || "",
    phone: studentData?.phone || "",
    citiz_no: studentData?.citiz_no || "",
    email: studentData?.email || "",
    bloodgroup: studentData?.bloodgroup || "",
    religion: studentData?.religion || "Hinduism",
    caste: studentData?.caste || "",
    sub_caste: studentData?.sub_caste || "",
    nationality: studentData?.nationality || "Nepalese",
    bus_facility: studentData?.bus_facility || "",
    dorm_facility: studentData?.dorm_facility || "",
    fath_ph: studentData?.fath_ph || "",
    moth_ph: studentData?.moth_ph || "",
    branchid: studentData?.branchid || "",
    remarks: studentData?.remarks || "",
    mem_cate_id: studentData?.mem_cate_id || "",
    user: studentData?.user || "",
    sglsn: studentData?.sglsn || "",
    saving_account_no: studentData?.saving_account_no || "",
    branch: studentData?.branch || "",
    roll_no: studentData?.roll_no || "",
    reg_no: studentData?.reg_no || "",
    symbol_no: studentData?.symbol_no || "",
    division: studentData?.division || "",
    passed_year: studentData?.passed_year || "",
    obt_marks: studentData?.obt_marks || "",
    sms_banking: studentData?.sms_banking || "",
    notification: studentData?.notification || "",
    sms_mob_no: studentData?.sms_mob_no || "",
    father_qualification: studentData?.father_qualification || "",
    mother_qualification: studentData?.mother_qualification || "",
    samePermanent: studentData?.is_same_per || false,
    dorm_facility: studentData?.dorm_facility || false,
    bus_facility: studentData?.bus_facility || false,
    disability: studentData?.disability || false,
    disability_type: studentData?.disability_type || "",
    isFromMartyrFamily: studentData?.isFromMartyrFamily || false,
    isMuktaKamaiya: studentData?.isMuktaKamaiya || false,
    ctz_issue_district: studentData?.ctz_issue_district || "",
    nid_no: studentData?.nid_no || "",
    t_province: studentData?.t_province || "",
    t_district: studentData?.t_district || "",
    t_municipality: studentData?.t_municipality || "",
    t_wardno: studentData?.t_wardno || "",
    t_tole: studentData?.t_tole || "",
    tole: studentData?.tole || "",
    t_house_no: studentData?.t_house_no || "",
    house_no: studentData?.house_no || "",
    father_occupation: studentData?.father_occupation || "",
    mother_occupation: studentData?.mother_occupation || "",
    f_email: studentData?.f_email || "",
    t_block_no: studentData?.t_block_no || "",
    edg: studentData?.edg || false,
    guardian_name: studentData?.guardian_name || "",
    guardian_occupation: studentData?.guardian_occupation || "",
    guardian_phone: studentData?.guardian_phone || "",
    guardian_address: studentData?.guardian_address || "",
    guardian_email: studentData?.guardian_email || "",
    m_email: studentData?.m_email || "",
    block_no: studentData?.block_no || "",
  };

  const NPNowDate = NepNowDateFormat();
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema:
      currentStep === 1
        ? validationSchema1
        : currentStep === 2
        ? validationSchema2
        : currentStep === 3
        ? validationSchema4
        : validationSchema3,
    onSubmit: async (values) => {
      if (currentStep === 1) {
        setStep(2);
      } else if (currentStep === 2) {
        setStep(3);
      } else {
        setStep(4);
      }
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("member_sn", values.member_sn);
      formData.append("middle_name", values.middle_name || "");
      formData.append("last_name", values.last_name);
      formData.append("name_nep", values.name_nep);
      if (values.province) {
        formData.append("province", values.province);
      }
      if (values.team) {
        formData.append("team", values.team);
      }
      if (values.district) {
        formData.append("district", values.district);
      }
      if (values.municipality) {
        formData.append("municipality", values.municipality);
      }
      formData.append("is_same_per", values.samePermanent);

      formData.append("disability", values.disability);
      formData.append("disability_type", values.disability_type);
      formData.append("isFromMartyrFamily", values.isFromMartyrFamily);
      formData.append("isMuktaKamaiya", values.isMuktaKamaiya);
      formData.append("ctz_issue_district", values.ctz_issue_district);

      formData.append("wardno", values.wardno);
      formData.append("add_nep", values.add_nep);
      formData.append("per_add", values.per_add);
      formData.append("tempadd", values.tempadd);
      formData.append("father_name", values.father_name);
      formData.append("mother_name", values.mother_name);
      formData.append("nid_no", values.nid_no);
      if (values.marital_status) {
        formData.append("marital_status", values.marital_status);
      }
      if (values.gender) {
        formData.append("gender", values.gender);
      }
      formData.append("dobe", BSToADConvert(values.dobn) || "");
      formData.append("dobn", values.dobn || "");
      formData.append("phone", values.phone);
      formData.append("reg_date_n", NPNowDate);
      formData.append("account_off", false);

      formData.append("citiz_no", values.citiz_no);
      if (values.maj_subj) {
        formData.append("maj_subj", values.maj_subj);
      }
      if (values.dorm_facility) {
        formData.append(
          "dorm_facility",
          values.dorm_facility === "2" ? "0" : "1"
        );
      }
      if (values.bus_facility) {
        formData.append(
          "bus_facility",
          values.bus_facility === "2" ? "0" : "1"
        );
      }
      formData.append("email", values.email || "");
      if (values.bloodgroup) {
        formData.append("bloodgroup", values.bloodgroup || "");
      }
      if (values.religion) {
        formData.append("religion", values.religion || "");
      }
      if (values.caste) {
        formData.append("caste", values.caste);
      }
      if (values.sub_caste) {
        formData.append("sub_caste", values.sub_caste);
      }
      formData.append("nationality", values.nationality);
      formData.append("fath_ph", values.fath_ph);
      formData.append("moth_ph", values.moth_ph);
      if (values.remarks) {
        formData.append("remarks", values.remarks);
      }
      formData.append("user", "1");
      if (values.reg_no) {
        formData.append("reg_no", values.reg_no);
      }
      if (values.symbol_no) {
        formData.append("symbol_no", values.symbol_no);
      }
      if (values.division) {
        formData.append("division", values.division);
      }
      formData.append("sms_mob_no", values.phone);
      if (values.passed_year) {
        formData.append("passed_year", values.passed_year);
      }
      if (values.destination) {
        formData.append("destination", values.destination);
      }
      if (values.obt_marks) {
        formData.append("obt_marks", values.obt_marks);
      }
      if (values?.mother_qualification) {
        formData.append("mother_qualification", values?.mother_qualification);
      }
      if (values?.father_qualification) {
        formData.append("father_qualification", values?.father_qualification);
      }
      formData.append("t_province", values?.t_province || "");
      formData.append("t_district", values?.t_district || "");
      formData.append("t_municipality", values?.t_municipality || "");
      formData.append("t_wardno", values?.t_wardno || "");
      formData.append("t_tole", values?.t_tole || "");
      formData.append("tole", values?.tole || "");
      formData.append("t_house_no", values?.t_house_no || "");
      formData.append("t_block_no", values?.t_block_no || "");
      formData.append("house_no", values?.house_no || "");
      formData.append("father_occupation", values?.father_occupation || "");
      formData.append("mother_occupation", values?.mother_occupation || "");
      formData.append("f_email", values?.f_email || "");
      formData.append("m_email", values?.m_email || "");
      formData.append("block_no", values?.block_no || "");
      formData.append("edg", values?.edg || false);
      formData.append("guardian_name", values?.guardian_name || "");
      formData.append("guardian_occupation", values?.guardian_occupation || "");
      formData.append("guardian_phone", values?.guardian_phone || "");
      formData.append("guardian_address", values?.guardian_address || "");
      formData.append("guardian_email", values?.guardian_email || "");
      if (values.photo && typeof values.photo !== "string") {
        formData.append("photo", values.photo);
      }
      if (currentStep === 4) {
        try {
          const res = await putDataToTheServer(
            AppURL.AcademicsURL +
              "academics-student-update-view/" +
              studentData?.member_sn,
            formData
          );
          if (res?.status === 200) {
            ToastSuccess(res?.message);
            setStep(1);
          } else if (res?.status === 400) {
            ToastWarning(res?.message);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  });

  const resetForm = () => {
    formik.resetForm();
  };

  return (
    <StudentEditFormData.Provider
      value={{
        ...formik,
        currentStep,
        setStep,
        resetForm,
        studentDetails,
        setStudentDetails,
      }}
    >
      {children}
    </StudentEditFormData.Provider>
  );
};

export default StudentEditFormProvider;
